
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.719 8.655l-3.094 4.054a.955.955 0 01-.68.265.94.94 0 01-.68-.273.898.898 0 01-.28-.67c0-.265.093-.491.28-.679l2.579-3.368-2.578-3.368a.914.914 0 01-.282-.67c0-.26.094-.484.282-.671a.927.927 0 01.68-.28c.265 0 .492.093.679.28l3.094 4.039c.187.187.281.41.281.67 0 .26-.094.484-.281.67zM8 14.986c-.01.031-.026.09-.047.18-.02.088-.036.147-.047.179l-.054.163-.079.164-.117.125-.164.109-.21.055-.282.023c-.25 0-.49-.13-.719-.39-.229-.26-.312-.51-.25-.748L8 .998C8.177.333 8.677 0 9.5 0c.23 0 .383.122.46.366.08.245.082.502.009.772L8 14.986zm-3.266-2.285a.94.94 0 01-.68.273.955.955 0 01-.679-.265L.281 8.655A.914.914 0 010 7.985c0-.26.094-.484.281-.671l3.094-4.04a.927.927 0 01.68-.28c.265 0 .492.094.68.28.187.188.28.411.28.671 0 .26-.093.484-.28.67l-2.579 3.37 2.578 3.367a.923.923 0 01.282.679.898.898 0 01-.282.67z","fill":"currentColor"}})])
          )
        }
      }
    